<template>
  <form class="create stack" v-on:submit.prevent="createStack()">
    <textarea class="form-stack-title" name="title" v-model="title" placeholder="Title"/></textarea>
    <textarea name="description" v-model="description" placeholder="Describe the purpose of this stack" rows="2">
    </textarea>
    <button type="submit">add</button>
  </form>
</template>

<script>
  import slug from '../../data/slug'
  import stackFunctions from '../../data/stackFunctions'
  import cardRepository from '../../data/cardRepository'
  export default {
    props: ['user'],
    data() {
      return {
        title: '',
        description: '',
      }
    },
    created() {
    },
    methods: {
        createStack () {
          if (this.title.trim() || this.description.trim()) {
              stackFunctions.create({
              title: this.title, 
              description: this.description,
              slug: slug.get(this.title),
              creator: this.user.uid
                }, 
                (err) => {
                  if (err) {
                      throw err
                }
                this.title = ''
                this.description = ''
                this.slug = ''             
              })
              
          }
        }
    }
  }
</script>


// WEBPACK FOOTER //
// CreateStack.vue?3268e50c